import React from 'react';
import './App.css';
import { ShellThemeProvider } from '@sede-enterprise/shell-ds-react-framework';
import AppContent from './authPages/AppContent';
import { NetCarbonIntensityProvider } from './context/NetCarbonIntensityContext';
function App() {
  return (
    <div className='App'>
      <ShellThemeProvider theme='light'>
        <NetCarbonIntensityProvider>
          <AppContent />
        </NetCarbonIntensityProvider>
      </ShellThemeProvider>
    </div>
  );
}

export default App;
